(() => {
  const normalize = value => String(value || '').trim().toLocaleLowerCase();
  const init = () => document.querySelectorAll('#CinematicContact').forEach(form => {
    const root = form.querySelector('[data-enquiry]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const q = selector => form.querySelector(selector);
    const words = root.dataset;
    const message = q('#c-message');
    const phone = q('#c-phone');
    const body = q('[data-enquiry-body]');
    const interests = q('[data-enquiry-interests]');
    const announcement = q('[data-enquiry-announcement]');
    const topics = [...root.querySelectorAll('[data-enquiry-topic]')];
    const panels = new Map(topics.map(input => {
      const node = root.querySelector('[data-enquiry-panel="' + input.value + '"]');
      return [input.value, { input, node, choices: [], list: node.querySelector('[data-enquiry-selected]'), select: node.querySelector('[data-enquiry-model]'), own: node.querySelector('[data-enquiry-own]'), text: node.querySelector('[data-enquiry-text]') }];
    }));
    const search = q('[data-enquiry-search]');
    const results = q('[data-enquiry-results]');
    const feedback = q('[data-enquiry-feedback]');
    let timer, request, sequence = 0, active = -1, suggestions = [];

    const sync = () => {
      const callback = q('[data-contact-method="phone"]').checked;
      const mode = callback ? 'phone' : 'email';
      const selected = topics.filter(input => input.checked);
      const lines = selected.map(input => {
        const panel = panels.get(input.value);
        const values = panel.choices.map(item => item.label + (item.url ? ' (' + item.url + ')' : ''));
        if (!panel.own.hidden) values.push(panel.text.value.trim() || words.own);
        if (input.value === 'shop' && search.value.trim()) values.push(words.query + ': ' + search.value.trim());
        return input.dataset.label + ': ' + (values.length ? values.join('; ') : words.help);
      });
      interests.value = selected.map(input => input.dataset.label).join(', ');
      const method = q('[data-contact-method="' + mode + '"]').value;
      const parts = [words.method + ': ' + method];
      if (lines.length) parts.push(words.summary + '\n' + lines.join('\n'));
      if (message.value.trim()) parts.push(words.message + '\n' + message.value.trim());
      body.value = parts.join('\n\n');
      phone.required = callback;
      message.required = !callback && !selected.length;
      const messageLabel = q('[data-contact-message-label]');
      messageLabel.textContent = messageLabel.dataset[message.required ? 'required' : 'optional'];
      for (const selector of ['[data-contact-expect]', '[data-contact-phone-label]', '[data-contact-send]']) {
        const node = q(selector);
        node.textContent = node.dataset[mode];
      }
    };
    const cancelSearch = () => {
      sequence += 1;
      clearTimeout(timer);
      if (request) request.abort();
      request = null;
      results.removeAttribute('aria-busy');
    };
    const closeSearch = () => {
      results.hidden = true;
      search.setAttribute('aria-expanded', 'false');
      search.removeAttribute('aria-activedescendant');
      active = -1;
    };
    const renderChoices = panel => {
      panel.list.replaceChildren();
      panel.choices.forEach(item => {
        const li = document.createElement('li');
        const text = document.createElement('span');
        text.textContent = item.label;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', words.remove.replace('[item]', item.label));
        remove.addEventListener('click', () => {
          panel.choices = panel.choices.filter(choice => choice.key !== item.key);
          renderChoices(panel);
          sync();
          announcement.textContent = words.removed.replace('[item]', item.label);
          (panel.select || (panel.input.value === 'shop' ? search : panel.text)).focus();
        });
        li.append(text, remove);
        panel.list.append(li);
      });
      panel.list.hidden = !panel.choices.length;
      if (panel.select) [...panel.select.options].forEach(option => {
        option.disabled = panel.choices.some(item => item.key === 'model:' + option.value);
      });
    };
    const addChoice = (panel, item) => {
      if (!panel.choices.some(choice => choice.key === item.key || normalize(choice.label) === normalize(item.label))) panel.choices.push(item);
      renderChoices(panel);
      sync();
      announcement.textContent = words.selected.replace('[item]', item.label);
    };
    const showOwn = panel => {
      panel.own.hidden = false;
      const button = panel.node.querySelector('[data-enquiry-write]');
      if (button) button.setAttribute('aria-expanded', 'true');
      panel.text.focus();
      sync();
    };
    const showTopic = panel => {
      panel.node.hidden = !panel.input.checked;
      panel.node.disabled = !panel.input.checked;
      if (panel.input.value === 'shop' && !panel.input.checked) {
        cancelSearch();
        closeSearch();
      }
    };
    panels.forEach(panel => {
      panel.input.addEventListener('change', () => { showTopic(panel); sync(); });
      panel.text.addEventListener('input', sync);
      panel.node.querySelector('[data-enquiry-write]')?.addEventListener('click', () => showOwn(panel));
      panel.select?.addEventListener('change', () => {
        const value = panel.select.value;
        if (!value) return;
        if (value === '__own') showOwn(panel);
        else addChoice(panel, { key: 'model:' + value, label: panel.select.selectedOptions[0].textContent });
        panel.select.value = '';
      });
    });
    const setFeedback = text => {
      feedback.textContent = text;
      feedback.hidden = !text;
    };
    const chooseProduct = index => {
      const item = suggestions[index];
      if (!item) return;
      cancelSearch();
      search.value = '';
      addChoice(panels.get('shop'), item);
      suggestions = [];
      results.replaceChildren();
      closeSearch();
      setFeedback('');
      search.focus();
    };
    const renderResults = products => {
      suggestions = [];
      results.replaceChildren();
      const seen = new Set();
      products.forEach(product => {
        if (!product.id || !product.title || !product.url || seen.has(String(product.id))) return;
        const url = new URL(product.url, location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
        seen.add(String(product.id));
        const item = { key: 'product:' + product.id, label: String(product.title), url: url.origin + url.pathname };
        if (panels.get('shop').choices.some(choice => choice.key === item.key)) return;
        const index = suggestions.length;
        suggestions.push(item);
        const option = document.createElement('li');
        option.id = results.id + '-' + index;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.textContent = item.label;
        option.addEventListener('pointerdown', event => event.preventDefault());
        option.addEventListener('click', () => chooseProduct(index));
        results.append(option);
      });
      if (!suggestions.length) {
        closeSearch();
        setFeedback(words.empty);
      } else {
        results.hidden = false;
        search.setAttribute('aria-expanded', 'true');
        setFeedback(words.count.replace('[count]', String(suggestions.length)));
      }
    };
    const runSearch = async (query, version) => {
      const controller = new AbortController();
      request = controller;
      let timedOut = false;
      const timeout = setTimeout(() => { timedOut = true; controller.abort(); }, 6000);
      try {
        const url = new URL(root.dataset.endpoint.replace(/\/$/, '') + '.json', location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid search origin');
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku');
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (version !== sequence || !root.isConnected || controller.signal.aborted) return;
        const products = data.resources?.results?.products;
        if (!Array.isArray(products)) throw new Error('Invalid search response');
        renderResults(products);
      } catch (error) {
        if (version === sequence && (error.name !== 'AbortError' || timedOut)) {
          closeSearch();
          setFeedback(words.unavailable);
        }
      } finally {
        clearTimeout(timeout);
        if (version === sequence) results.removeAttribute('aria-busy');
        if (request === controller) request = null;
      }
    };
    search.addEventListener('input', () => {
      cancelSearch();
      closeSearch();
      suggestions = [];
      results.replaceChildren();
      sync();
      const query = search.value.trim();
      if ([...query].length < 2) { setFeedback(''); return; }
      setFeedback(words.loading);
      results.setAttribute('aria-busy', 'true');
      const version = sequence;
      timer = setTimeout(() => runSearch(query, version), 180);
    });
    search.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        cancelSearch();
        closeSearch();
        setFeedback('');
        return;
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        if (!results.hidden && active >= 0) chooseProduct(active);
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || !suggestions.length) return;
      event.preventDefault();
      results.hidden = false;
      search.setAttribute('aria-expanded', 'true');
      active = event.key === 'ArrowDown' ? (active + 1) % suggestions.length : (active <= 0 ? suggestions.length - 1 : active - 1);
      [...results.children].forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
      search.setAttribute('aria-activedescendant', results.children[active].id);
      results.children[active].scrollIntoView({ block: 'nearest' });
    });
    root.addEventListener('focusout', event => {
      if (event.target === search && !results.contains(event.relatedTarget)) {
        cancelSearch();
        closeSearch();
        if (feedback.textContent === words.loading) setFeedback('');
      }
    });
    search.addEventListener('focus', () => {
      if (suggestions.length) { results.hidden = false; search.setAttribute('aria-expanded', 'true'); }
    });
    message.addEventListener('input', sync);
    form.addEventListener('submit', sync);
    const params = new URLSearchParams(location.search);
    const poolChoice = (params.get('guideval') || params.get('poolval') || '').trim().slice(0, 1800);
    if (poolChoice && !message.value.trim()) message.value = poolChoice;
    if (params.get('kontakt') === 'telefon') q('[data-contact-method="phone"]').checked = true;
    q('[data-enquiry-fallback]').hidden = true;
    q('[data-enquiry-fallback]').querySelectorAll('input,select').forEach(input => {
      input.disabled = true;
      input.removeAttribute('name');
    });
    message.removeAttribute('name');
    body.disabled = false;
    interests.disabled = false;
    root.hidden = false;
    const aliases = { pool: 'pool', pooler: 'pool', spabad: 'spa', spa: 'spa', pooltak: 'roof', swimspa: 'swimspa', service: 'service', webbshop: 'shop', övrigt: 'other' };
    const requested = params.getAll('intresse').flatMap(value => value.split(/[,|]/));
    requested.forEach(value => {
      const key = aliases[normalize(value)];
      if (panels.has(key)) panels.get(key).input.checked = true;
    });
    const model = (params.get('modell') || '').trim().slice(0, 500);
    if (model) {
      let panel = [...panels.values()].find(item => item.input.checked);
      if (!panel) panel = [...panels.values()].find(item => item.select && [...item.select.options].some(option => normalize(option.value) === normalize(model))) || panels.get('other');
      panel.input.checked = true;
      const match = panel.select && [...panel.select.options].find(option => normalize(option.value) === normalize(model));
      addChoice(panel, { key: match ? 'model:' + match.value : 'prefill:' + model, label: match ? match.textContent : model });
    }
    panels.forEach(showTopic);
    q('[data-contact-method]').closest('fieldset').addEventListener('change', () => {
      sync();
      const url = new URL(location.href);
      if (q('[data-contact-method="phone"]').checked) url.searchParams.set('kontakt', 'telefon');
      else url.searchParams.delete('kontakt');
      history.replaceState(history.state, '', url);
      updateReturn();
    });
    const updateReturn = () => {
      const returnTo = q('[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + '#CinematicContact';
    };
    sync();
    updateReturn();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

